"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Heading = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Text = exports.Text = function Text(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "p",
    tx: "text"
  }, props, {
    __css: {
      fontFamily: 'primary'
    }
  }));
};
var Heading = exports.Heading = function Heading(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "h2",
    tx: "text"
  }, props, {
    __css: {
      fontSize: 4,
      fontWeight: 'heading',
      fontFamily: 'primary',
      lineHeight: 'heading',
      letterSpacing: 'heading',
      color: 'neutral.6'
    }
  }));
};